import { render } from "./Multiplicador.vue?vue&type=template&id=5e71467a&scoped=true"
import script from "./Multiplicador.vue?vue&type=script&lang=js"
export * from "./Multiplicador.vue?vue&type=script&lang=js"

import "./Multiplicador.vue?vue&type=style&index=0&id=5e71467a&scoped=true&lang=scss"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e71467a"]])

export default __exports__